import { AloftPrice } from '@aloft/toolkit-shared';
import { Block, Typography } from '@aloft/toolkit-sui';

import { get } from 'lodash';
import { Fragment } from 'react';

import { TdGap } from './TdGap.js';
import {
  AdjustmentRollups,
  FeaturesAndAdjustments,
  PairedCostAdjustmentSummaryProps,
} from './types.js';
import { getColorFromAdjustment } from './utils/getColorFromAdjustment.js';

export const PairedCostAdjustmentSummaryTableRollupRow = ({
  comps,
  compSequence,
  label,
  path,
  includeTopBorder = false,
  bold = false,
  isSimplifiedMode: showSummaryColumn,
}: PairedCostAdjustmentSummaryProps & {
  label: string;
  path: keyof FeaturesAndAdjustments | keyof AdjustmentRollups;
  includeTopBorder?: boolean;
  bold?: boolean;
}) => {
  const typographyVariant = bold ? 'h4' : 'body1';

  return (
    <tr className={includeTopBorder ? 'top-border' : undefined}>
      <th className="data-cell">
        <Block className="data-cell-position-wrapper">
          <Typography variant={typographyVariant}>{label}</Typography>
        </Block>
      </th>
      <th className="data-cell" colSpan={showSummaryColumn ? 2 : 1} />
      {compSequence.map((compID, idx) => (
        <Fragment key={`summary-row-${label}-${compID}`}>
          <TdGap isSticky={idx === 0} />
          <td className="data-cell right-align" colSpan={2}>
            <Block className="data-cell-position-wrapper">
              <Typography
                variant={typographyVariant}
                color={getColorFromAdjustment(
                  get(comps, `${compID}.${path}.adjustment`) as unknown as AloftPrice | undefined,
                )}
              >
                {(get(comps, `${compID}.${path}.value`) as unknown as string | undefined) ?? ''}
              </Typography>
            </Block>
          </td>
        </Fragment>
      ))}
    </tr>
  );
};
